const locale = {
  general: {
    language: 'English',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    apply: 'Apply',
    continue: 'Continue',
    confirm: 'Understood',
    save: 'Save',
    close: 'Close',
    loading: 'Loading, please wait ...',
    errorHeader: 'Error',
    errorEmptyField: 'Required field',
    errorEmptyFields: 'Required field is empty',
    errorInvalidEmail: 'Invalid email',
    successHeader: 'Success',
    successfullySaved: 'Successfully saved',
    successfullyVerified: 'Successfully verified',
    errorStampUpload: 'Stamp upload error'
  },
  oneTwoBuildNotifySales: {
    text: '12Build integration not activated, contact your site maintainer for activation.'
  },
  treeView: {
    rootFolderName: 'Office',
    title: 'Folders',
    allFolder: 'All folders',
    favoriteFolder: 'Favorite folders',
    newDocs: 'New documents',
    workBox: 'Workbox',
    newDocsDescription: 'Documents from the last 7 days'
  },
  toolbar: {
    new: 'New',
    import: 'Import document',
    newViaTemplate: 'New document from template',
    expected: 'Expected documents',
    newFolder: 'New folder',
    newFolderViaTemplate: 'New folder from template',
    show: 'Show',
    edit: 'Edit',
    publish: 'Publish',
    search: 'Search',
    status: 'Status',
    stamp: 'Stamp',
    QRCode: 'QR-code',
    message: 'Message',
    printOrder: 'Print order',
    version: 'Version',
    view: 'View',
    extra: 'Extra'
  },
  mainNav: {
    documents: 'Documents',
    management: 'Management',
    messages: 'Messages',
    contacts: 'Contacts',
    procedures: 'Procedures'
  },
  login: {
    username: 'Username',
    usernameWithEmail: 'E-mail',
    password: 'Password',
    login: 'Login',
    or: 'or',
    back: 'Back',
    employeeOf: 'Employee of Pro4all',
    portal: 'Pro4All Portal',
    reset: 'Reset password',
    resetText: 'Fill in your new password.',
    resetBadPassFirst: 'The specified password is invalid. The password cannot have been used before, must consist of at least ',
    resetBadPassSecond: ' characters, and must contain ',
    resetBadPassThird: ' non-alphanumeric character.',
    resetDiffer: 'The passwords do not match.',
    resetSave: 'Save',
    resetNew: 'New password',
    resetConfirm: 'Confirm password',
    resetSuccess: 'The password has been set. Go back and log in with your new password.',
    resetFail: 'The link is incorrect or no longer valid',
    forgotPassword: 'Forgot password?',
    forgotPasswordText: 'Enter your username to receive a new password',
    forgotPasswordTextWithEmail: 'Enter your email to receive a new password',
    forgotPasswordFail: 'No username specified',
    forgotPasswordFailEmail: 'Invalid email format specified',
    forgotPasswordSuccessFirst: 'If the given username exists in Docstream, you should receive an e-mail containing a link to reset the password. This action can be done up to ',
    forgotPasswordSuccessFirstWithEmail: 'If the given e-mail exists in Docstream, you should receive an e-mail containing a link to reset the password. This action can be done up to ',
    forgotPasswordSuccessSecond: ' times a day.',
    forgotPasswordSuccessTimeFirst: 'Please note that the sent link is only valid for ',
    forgotPasswordSuccessTimeSecond: ' minutes.',
    expired: 'Your session has expired',
    expiredText: 'The session has expired due to your inactivity in docstream. Press the button below to log in again.',
    doubleLogin: 'Username already logged in!',
    doubleLoginFirstHeader: 'Cause:',
    doubleLoginFirstText: 'The cause of this message is that you are already logged in on another computer with the same user details.',
    doubleLoginSecondHeader: 'Solution:',
    doubleLoginSecondText: 'First save your progress on the other computer, then log out there and log in again.',
    wrongLoginTitle: 'Login failed',
    wrongLogin: 'Check the credentials and try again',
    wrongEmailFormat: 'Invalid email format',
    wrongEmail: 'Enter a valid email address',
    loginRequestError: 'There was a problem trying to login.',
    introText: 'Manage all your projects and documents in one place',
    send: 'Send e-mail',
    loggedOut: 'You are logged out.',
    loggedOutText: 'You are logged out of docstream. Press the button below to log in again.',
    OIDCErrorHeader: 'Failed to log in',
    OIDCErrorFirstText: 'We could not log you in with your external account. You may not have set up an external account.',
    OIDCErrorSecondText: 'To set up your external account, log in with your Docstream credentials and configure your external account in [Tools -> External account].',
    mfaTitle: 'Verify your account',
    mfaDescription: 'You can find the 2-step verification code in the authentication app.',
    mfaPlaceholder: 'Enter the code',
    mfaButton: 'Log in',
    mfaTitleSetup: 'Verify your account',
    mfaDescriptionSetup: 'Open the authenticator-app on your smartphone.',
    mfaTitleSetup2: 'Just scan',
    mfaDescriptionSetup2: 'Scan the QR code in the authentication-app on your smartphone.',
    mfaTitleSetup3: 'Enter the code',
    mfaDescriptionSetup3: 'Enter the six digits here that appear in the authentication app.',
    mfaDescriptionCode: 'Use the following code manually:',
    mfaButtonSetup: 'Confirm code'
  },
  loginCarousel: {
    slideTitle: 'Meet Prostream',
    slideText: 'The latest way to manage documents and projects. {slideLinkText} for more information.',
    slideLinkText: 'Click here'
  },
  newFolder: {
    title: 'Create new folder',
    subTitle: 'Folder Name',
    inputText: 'Specify folder name',
    cancelButton: 'Cancel',
    acceptButton: 'Ok',
    errorMessage: 'Folder name must contain minimally 1 character and may contain 255 characters maximal and not any of the following characters: \\/:*?"<>|.'
  },
  usersInformation: {
    headerTitle: 'User Information',
    tabs: {
      title: 'Settings',
      general: 'General',
      personalInformation: 'Personal information',
      companyInformation: 'Company information',
      signature: 'Signature',
      verify: '2 factor authentication',
      stamp: 'Stamp'
    },
    buttons: {
      close: 'Close',
      save: 'Save'
    },
    general: {
      title: 'General',
      text: 'Enter your general settings here. Please note that all adjustments affect the entire environment.',
      username: 'Username',
      name: 'Name',
      email: 'E-mailadres',
      toInform: 'To inform',
      dropdownPlaceholder: 'Select option ...',
      dropdownOptions: ['Yes, all folders', 'Yes, specified folders', 'No', 'Yes, specified favourite folders'],
      description: 'Description',
      password: 'Password',
      confirmPassword: 'Confirm password',
      passwordChange: 'Adjust',
      resetEmail: 'Send reset e-mail'
    },
    personal: {
      title: 'Personal information',
      text: 'Enter your general settings here. Please note that all adjustments affect the entire environment.',
      firstName: 'First Name',
      lastName: 'Last name',
      prefixes: 'prefixes',
      email: 'E-mailadres',
      workphone: 'Work number',
      mobile: 'Mobile number',
      checkbox: 'I want to receive the newsletter'
    },
    company: {
      title: 'Business data',
      text: 'Enter your general settings here. Please note that all adjustments affect the entire environment.',
      name: 'Company Name',
      function: 'Position'
    },
    signature: {
      title: 'Signature',
      text: 'Your signature is used in all mail correspondence.'
    },
    verify: {
      title: '2 factor authentication',
      text1: 'Scan the QR-code with a ‘two factor authentication App’ to secure your account. Next time you log in, will need to use the code from the App to confirm that it is you who wants to log in.',
      text2: 'Once you scanned this QR-code a numeric code will appear. Insert that code and confirm to connect the app with your account.',
      disabledText: 'The 2 factor authenticatie is already activated. You can deactivate it or find the TOIP-code to share your account or connect to a ‘password vault’.',
      confirm: 'Confirm',
      disable: 'deactivate'
    },
    stamp: {
      title: 'Stamp',
      text: 'Add stamp',
      noImage: 'No image',
      upload: 'upload',
      fileExtension: 'Only .PNG images can be used as a stamp.'
    }
  },
  folderProperties: {
    general: {
      title: 'General',
      form: {
        label1: 'Folder name',
        label2: 'Folder created by',
        label3: 'Folder creation date',
        label4: 'Folder capacity',
        label5: 'Metadata set',
        label6: 'Project',
        label7: 'Snagstream project',
        notLinked: 'Not linked',
        checkbox1: 'Project folder',
        checkbox2: 'Trusted folder',
        unlinkButton: 'Unlink'
      }
    },
    procedure: {
      title: 'Procedure',
      form: {
        checkbox: 'Automatically start a new procedure when placing a document (version)',
        label1: 'Standard',
        label2: 'Owner'
      }
    },
    requiredDocuments: {
      title: 'Required documents',
      form: {
        label: {
          line1: 'Enter the required document names for this folder below',
          line2: '(Every name on a new line)'
        },
        textareaPlaceholder: ''
      }
    }
  },
  folderRights: {
    header: {
      title: 'Permissions on',
      searchPlaceholder: 'Search…'
    },
    table: {
      header: {
        Name: {
          title: 'Name',
          bodyTitle: 'Information',
          bodyText: [
            'Some of the folderrights have two columns, you will find an explanation below.',
            'The first column displays the specific folder right on the current folder.',
            'The second column shows that the subfolders also have the specific folder right.'
          ]
        },
        IL: {
          bodyTitle: 'Internal viewer',
          bodyText: [
            'All documents are visible, regardless of the status of the document.'
          ]
        },
        EL: {
          bodyTitle: 'External viewer',
          bodyText: [
            'Documents with status \'Approve\' are visible.'
          ]
        },
        DL: {
          bodyTitle: 'Final viewer',
          bodyText: [
            'Documents with both \'Approve\' and \'Freeze\' statuses are visible.'
          ]
        },
        ET: {
          bodyTitle: 'External team member',
          bodyText: [
            'Documents with status \'Approve\' are visible.',
            'My own documents are visible.',
            'Create new documents.',
            'Change my own documents.',
            'You can give documents the status \'Approve\' or undo this.',
            'You can only delete your own documents.'
          ]
        },
        A: {
          bodyTitle: 'Folder assistent',
          bodyText: [
            'All documents are visible, regardless of the status of the document.',
            'Create new documents.',
            'Change documents.',
            'You can only delete your own documents.'
          ]
        },
        IT: {
          bodyTitle: 'Internal member',
          bodyText: [
            'All documents are visible, regardless of the status of the document.',
            'Create new documents.',
            'Delete documents.',
            'Change documents.',
            'You can give documents the status \'Approve\' or undo this.'
          ]
        },
        '+': {
          bodyTitle: 'Create subfolders',
          bodyText: [
            'Create new folders.'
          ]
        },
        EV: {
          bodyTitle: 'Final responsible member',
          bodyText: [
            'You can give documents the status \'Freeze\' or undo this.'
          ]
        },
        B: {
          bodyTitle: 'Coordinator',
          bodyText: [
            'All documents are visible, regardless of the status of the document.'
          ]
        },
        PB: {
          bodyTitle: 'Contacts administrator',
          bodyText: [
            'You are a contacts administrator.'
          ]
        },
        PC: {
          bodyTitle: 'Workflow coördinator',
          bodyText: [
            'Set a procedure to documents.'
          ]
        },
        I: {
          bodyTitle: 'Inform',
          bodyText: [
            'With this field you can give a user notification on the current- and subfolders.'
          ]
        },
        Alternative: {
          EL: {
            bodyText: 'Documents with status \'{0}\' are visible.'
          },
          DL: {
            bodyText: 'Documents with both \'{0}\' and \'{1}\' statuses are visible.'
          },
          ET: {
            bodyText1: 'Documents with status \'{0}\' are visible.',
            bodyText2: 'My own documents are visible.',
            bodyText3: 'Create new documents.',
            bodyText4: 'Change my own documents.',
            bodyText5: 'You can give documents the status \'{0}\' or undo this.',
            bodyText6: 'You can only delete your own documents.'
          },
          IT: {
            bodyText1: 'All documents are visible, regardless of the status of the document.',
            bodyText2: 'Create new documents.',
            bodyText3: 'Delete documents.',
            bodyText4: 'Change documents.',
            bodyText5: 'You can give documents the status \'{0}\' or undo this.'
          },
          EV: {
            bodyText: 'You can give documents the status \'{0}\' or undo this.'
          },
          Default: 'Approve',
          DefaultFinal: 'Freeze'
        }
      }
    },
    buttons: {
      cancel: 'Cancel',
      exchange: 'Exchange',
      modify: 'Modify',
      close: 'Close',
      save: 'Save',
      removeAll: 'Remove all'
    }
  },
  CommentDialog: {
    downloadAttachmentTitle: '{0} attachments',
    closeButtonText: 'Close',
    downloadButton: 'Download ({0})',
    errorMessage: 'The files you requested are not available or you do not have access to them'
  },
  DocumentGrid: {
    noOptionsAvailable: 'No options available',
    EmptyFolder: 'No documents available',
    DocumentNotLoaded: 'Unable to retrieve documents',
    searchingFilters: 'Searching filters',
    selectedDocuments: '({0} document(s) selected)',
    checkVersionError: 'Unable to check selected versions',
    loadingGridMessage: 'Loading',
    LoadingErrorMessage: 'The current page could not be loaded, try again later or report the error',
    ApplyFilter: 'Apply filter',
    RemoveFilters: 'Remove filters',
    SearchAllFolders: 'search in all folders',
    ascending: 'Ascending',
    descending: 'Descending',
    facetFilter: 'Search...',
    selectAll: 'Select all',
    deSelectAll: 'Deselect All'
  }
}

export default locale



// WEBPACK FOOTER //
// ./src/localization/locales/en.js